"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Block = /** @class */ (function () {
    function Block(data) {
        this.id = data.id;
        this.type = data.type;
        this.props = data.props;
        this.meta = data.meta;
        this.children = data.children;
        this.animator = data.animator;
    }
    Block.new = function () {
        return new Block({});
    };
    return Block;
}());
exports.Block = Block;
exports.cloneBlock = function (block) {
    var children = Array.isArray(block.children) ? __spreadArrays(block.children) : block.children;
    return __assign(__assign({}, block), { children: children, props: __assign({}, block.props) });
};
